import { useState, useEffect, useContext  } from "react";
import {Box,  Typography,  Button,  useTheme,  Card,  CardContent,  CardActions,  Divider,  Grid,  Chip,  Modal,
  Tooltip,} from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import ProgressBar from "../../components/ProgressBar";
import { fetchData } from "../../services/Api";
import BarChart from "../../components/BarChart";
import DatosContext from "../vocacional/AppContext";
import axios from "axios"; 
import EmailTemplate from "../../components/Email";
import ReactDOMServer from "react-dom/server";
import html2canvas from "html2canvas";
import logo from "../../assests/CircularFullColor.png";
import { isMobile } from "react-device-detect";


const urlVocacion = process.env.REACT_APP_API_BASE_URL

const Test = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [likedQuestions, setLikedQuestions] = useState([]);
  const [dislikedQuestions, setDislikedQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [areas, setAreas] = useState([]);
  const [likedQuestionIds, setLikedQuestionIds] = useState([]);
  const [dislikedQuestionIds, setDislikedQuestionIds] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  
  

  let imageBase64 = "";
  const { datosCompartidos } = useContext(DatosContext);

 // console.log("Datos com:", datosCompartidos);

  const totalRespuestas = questions.length;
  const respuestasCompletadas =
    likedQuestions.length + dislikedQuestions.length;

   
     useEffect(() => {
      const cargarDatos = async () => {
        try {
          const PreguntasData = await fetchData("ObtenerPreguntasInteres/"); 
          // Agrega likedAnswerId y dislikedAnswerId si no existen

          const preguntasConIDs = PreguntasData.map((pregunta) => ({
            ...pregunta,
            likedAnswerId: pregunta.likedAnswerId || "likedAnswerId_no_definido",
            dislikedAnswerId: pregunta.dislikedAnswerId || "dislikedAnswerId_no_definido",
          }));
          setQuestions(preguntasConIDs); // Guardar los datos de preguntas         
        } catch (error) {
          console.error("Error al cargar datos:", error);
        }
      };
      cargarDatos();
    }, []);


    useEffect(() => {
      const cargarAreas = async () => {
        try {
          const areasData = await fetchData("ObternerListaAreaInteres/");          
          setAreas(areasData); // Cambiado para guardar en el estado correcto
       //   console.log("Datos de áreas:", areasData);    
        } catch (error) {
          console.error("Error al cargar datos:", error);
        }
      };
      cargarAreas();
    }, []);


  // Manejar la respuesta y agregar la pregunta al box correspondiente
  const handleAnswer = (liked) => {
    const currentQuestion = questions[currentQuestionIndex];
    //console.log("Pregunta actual:", currentQuestion);

    // Verificar si la respuesta está definida
    
    if (liked) {
      // Guardar la pregunta completa
      setLikedQuestions((prev) => [...prev, currentQuestion]);
      // Guardar solo los IDs, si hay una respuesta definida
      setLikedQuestionIds((prev) => [
        ...prev,
        {
          questionId: currentQuestion.id,
          answerId: '1', // Usar el ID real de la respuesta si está disponible
        },
      ]);
    } else {
      // Guardar la pregunta completa
      setDislikedQuestions((prev) => [...prev, currentQuestion]);
      // Guardar solo los IDs, si hay una respuesta definida
      setDislikedQuestionIds((prev) => [
        ...prev,
        {
          questionId: currentQuestion.id,
          answerId: '2', // Usar el ID real de la respuesta si está disponible
        },
      ]);
    }

    // Mover a la siguiente pregunta   
    const nextIndex = currentQuestionIndex + 1;

    // Verificar si se completaron todas las preguntas
    if (nextIndex >= questions.length) {
      setIsCompleted(true);
    } else {
      setCurrentQuestionIndex(nextIndex);
    }
};

  //console.log("Liked Question IDs:", likedQuestionIds);
  //console.log("Disliked Question IDs:", dislikedQuestionIds);

  const getTopAreas = () => {
   // console.log("Estado de likedQuestions:", likedQuestions);
   // console.log("Estado de areas:", areas);
  
    const areaCounts = likedQuestions.reduce((acc, question) => {
      acc[question.idAreaInteres] = (acc[question.idAreaInteres] || 0) + 1;
      return acc;
    }, {});
  
    return Object.entries(areaCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 3) // Tomar solo las primeras 3 áreas
      .map(([idAreaInteres, count]) => {
        const area = areas.find((area) => area.id === parseInt(idAreaInteres));
       // console.log(`ID buscado: ${idAreaInteres}, Resultado:, Area: ${area},`);
        return {
          area: area ? area.areaInteres : "Desconocido",
          descripcion: area ? area.descripcion : "Sin descripción disponible",
          carreras: area ? area.carreras : [],
          respuestas: count,
        };
      });
  };

  const dataResultado = getTopAreas(); // Llama a la función para obtener los datos

  const enviarCorreo = async (datosCompartidos) => {
   // alert('cualquiermierda')
    try {
      // Renderizar el contenido del correo usando la plantilla
      const htmlContent = ReactDOMServer.renderToStaticMarkup(
        <EmailTemplate
          recipientName={datosCompartidos.nombreCompleto || "Usuario"}
          estado="Completado"
         // numeroSolicitud="N/A"
          tipo="Test de Interés Vocacional"
          observaciones="gracias por completar el cuestionario. Se adjunta el resultado del test realizado. Para más información, contactanos si estás interesado en ser parte de nuestra gran familia."
        />
      );
  
      // Solicitud para enviar el correo
      const response = await axios.post(urlVocacion + "EnviarCorreo", {
        from: "testvocacional@unicah.edu",
        to: datosCompartidos.correoElectronico || "eespinoza@unicah.edu",
        subject: "Resultados del Test de Interés Vocacional",
        attachment: imageBase64, // Agrega la imagen capturada como un adjunto
        message: htmlContent,
      });
  
      if (response.status === 200) {
        console.log("Correo enviado exitosamente:", response.data);
      } else {
        console.error("Error al enviar el correo:", response.data);
      }
    } catch (error) {
      console.error("Error al enviar el correo:", error);
    }
  };

  const capturarModal = async () => {
    try {
      const modalElement = document.getElementById("modal-container"); // Asegúrate de que el modal tenga este ID
  
      if (!modalElement) {
        console.error("No se encontró el modal para capturarlo.");
        return null;
      }
          // Oculta el botón antes de la captura
            setIsButtonVisible(false);

      // Capturar el contenido del modal como imagen
      // Da un pequeño tiempo para garantizar que el cambio de estado se refleje en el DOM
      setTimeout(async () => {
        // Capturar el contenido del modal como imagen
        const canvas = await html2canvas(modalElement, {
          scale: 2, // Escala para mejorar la calidad
          useCORS: true, // Permite capturar imágenes externas si están en el modal
          logging: false, // Desactiva logs internos de html2canvas
        });
  
  
      // Convertir la captura en base64
      imageBase64 = canvas.toDataURL("image/png");
      console.log("Captura realizada con éxito.");
      enviarCorreo(datosCompartidos);
      // Vuelve a mostrar el botón después de la captura
       setIsButtonVisible(true);

      return imageBase64;
      }, 300); // Retraso de 300ms para asegurar el DOM actualizado
    } catch (error) {
      console.error("Error al capturar el modal:", error);
      // En caso de error, vuelve a mostrar el botón
    setIsButtonVisible(true);
      return null;
    }
  };


  const handleSubmit = async () => {
    try {
      const payload = {
        datosFormulario: datosCompartidos, // Datos del formulario
        respuestasTest: [...likedQuestionIds, ...dislikedQuestionIds], // Respuestas del test
      };
     // Llamar a la función enviarCorreo
       //enviarCorreo(datosCompartidos);
      // Llamada al endpoint de tu backend
      const response = await axios.post(urlVocacion + "InsertarDatosFormulario", payload);
      
      if (response.status === 200) {
        console.log("Datos guardados correctamente:", response.data);
        
       
      } else {
        console.error("Error al guardar datos:", response.data);
      }
    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
    }
  };

  // Abrir o cerrar el modal
  const handleOpenModal = async () => {
    setOpenModal(true); // Abre el modal

  // Forzar renderizado
  await new Promise((resolve) => setTimeout(resolve, 500)); // 500 ms para esperar animaciones

  const imageBase64 = await capturarModal(); // Captura el modal

  if (imageBase64) {
    console.log("Imagen capturada:", imageBase64);
  }
  };

  const handleCloseModal = () => {
    
    setOpenModal(false);

    // Redirige a otra página
  window.location.href = "https://www.unicah.edu/";
  
  }

  return (
    <Box m="20px">
      <Header title="Test de Interes Vocacional" subtitle="" />
      <Divider sx={{ my: 1, mb: 2 }} />
      <Typography variant="body1" align="justify">
        <strong>INSTRUCCIONES:</strong> A continuación, encontrarás un listado
        de preguntas en la sección central llamada "Listado de preguntas." Te
        sugerimos leer cada pregunta detenidamente y reflexionar sobre su
        contenido antes de responder. Una vez que comprendas la pregunta,
        selecciona "Sí" para que se agregue a la columna de "Sí me gustaría" o
        "No" para que se añada a la columna de "No me gustaría," según tu
        afinidad o interés con el tema planteado. Recuerda que la precisión de
        los resultados depende de tu honestidad al responder.
      </Typography>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12}>
          <ProgressBar
            totalRespuestas={totalRespuestas}
            respuestasCompletadas={respuestasCompletadas}
          />
        </Grid>
      </Grid>

      <Grid container key="divider-Izq" spacing={2} alignItems="center">
        {/* Sección "Si me gustaría" */}
        <Grid item xs={12} sm={4}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 2 }}
          >
            <Divider key="divider-Izquierda" sx={{ flexGrow: 1 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mx={2}
            >
              Si me gustaría
            </Typography>
            <Divider sx={{ flexGrow: 1 }} />
          </Box>
          <Box
            sx={{
              backgroundColor: `${colors.greenAccent[800]}33`,
              borderRadius: "15px",
              boxShadow: 3,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
              minHeight: "300px",
              height: "300px",
              transition: "all 0.3s ease",
            }}
          >
            {/* Contenido específico para "Si me gustaría" */}
            {likedQuestions.map((question) => (
              <Chip
                key={question.idPregunta}
                label={question.text}
                //onDelete={() => handleDelete(question.idPregunta, true)}
                sx={{
                  m: 0.5,
                  backgroundColor: colors.greenAccent[300],
                  color: "white",
                }}
              />
            ))}
          </Box>
        </Grid>

        {/* Sección "Listado de preguntas" */}
        <Grid item xs={12} sm={4}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 2 }}
          >
            <Divider sx={{ flexGrow: 1 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mx={2}
              sx={{ lineHeight: 1.25 }} // Ajusta el lineHeight para mejorar la alineación
            >
              Listado de preguntas
            </Typography>
            <Divider sx={{ flexGrow: 1 }} />
          </Box>
          <Box
            sx={{
              backgroundColor: `${colors.softWhiteAccent[100]}11`,
              borderRadius: "15px",
              boxShadow: 3,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
              minHeight: "300px",
            }}
          >
            {/* Contenido de las preguntas */}
            {currentQuestionIndex < questions.length && (
              <Card
                sx={{
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  borderRadius: "10px",
                  boxShadow: 4,
                  background: `linear-gradient(135deg, ${colors.softWhiteAccent[100]}33, ${colors.softWhiteAccent[300]}33)`,
                }}
              >
                {!isCompleted ? (
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.8rem" }}
                    >
                      {currentQuestionIndex + 1}. ¿Te gustaría?
                    </Typography>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{ mt: 2, fontSize: "1.2rem" }}
                    >
                      {questions[currentQuestionIndex].text}
                    </Typography>
                  </CardContent>
                ) : (
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      padding: 4,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.8rem", mb: 2 }}
                    >
                      ¡Cuestionario Completado!
                    </Typography>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      Gracias por completar todas las preguntas.
                    </Typography>
                  </CardContent>
                )}
                {!isCompleted && (
                  <CardActions sx={{ justifyContent: "space-evenly", p: 2 }}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "white",
                        "&:hover": { backgroundColor: colors.greenAccent[700] },
                        borderRadius: "20px",
                        width: "40%",
                      }}
                      onClick={() => handleAnswer(true)}
                    >
                      Sí
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: colors.redAccent[500],
                        color: "white",
                        "&:hover": { backgroundColor: colors.redAccent[700] },
                        borderRadius: "20px",
                        width: "40%",
                      }}
                      onClick={() => handleAnswer(false)}
                    >
                      No
                    </Button>
                  </CardActions>
                )}
              </Card>
            )}
          </Box>
        </Grid>

        {/* Sección "No me gustaría" */}
        <Grid item xs={12} sm={4}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 2 }}
          >
            <Divider sx={{ flexGrow: 1 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mx={2}
            >
              No me gustaría
            </Typography>
            <Divider sx={{ flexGrow: 1 }} />
          </Box>
          <Box
            sx={{
              backgroundColor: `${colors.redAccent[700]}33`,
              borderRadius: "15px",
              boxShadow: 3,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
              minHeight: "300px",
              height: "300px",
              transition: "all 0.3s ease",
            }}
          >
            {/* Contenido específico para "No me gustaría" */}
            {dislikedQuestions.map((question) => (
              <Chip
                key={question.idPregunta}
                label={question.text}
                //onDelete={() => handleDelete(question.idPregunta, false)}
                sx={{
                  m: 0.5,
                  backgroundColor: colors.redAccent[500],
                  color: "white",
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Botón para abrir el modal */}
      <Box mt={4} textAlign="center">
        <Button
          color="primary"
          onClick={async () => {
            await handleSubmit(); // Insertar datos al backend
            handleOpenModal(); // Abrir el modal después de insertar
          }}
          disabled={respuestasCompletadas < totalRespuestas}
          variant="contained"
          sx={{
            backgroundColor: colors.greenAccent[300],
            color: "white",
            "&:hover": { backgroundColor: colors.greenAccent[300] },
            borderRadius: "20px",
            width: "40%",
          }}
        >
          Ver Top de Áreas de Interés
        </Button>
      </Box>

      {/* Modal para mostrar el top de áreas de interés */}
      <Modal
        id="modal-container"
        open={openModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseModal();
          }
        }}
      >
        <Box
          id="modal-container"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: "80vw", md: "70vw" }, // Ancho relativo a la pantalla
            maxWidth: "1200px",
            height: { xs: "95vh", sm: "auto" }, // Altura máxima en pantallas pequeñas
            maxHeight: "90vh", // Limitar altura en pantallas más grandes
            bgcolor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
            p: { xs: 1, sm: 3 },
            overflow: "visible", // Asegurar que el contenido no se salga
            display: "flex",
            flexDirection: "column",
            "@media (max-height: 600px)": {
              transform: "scale(0.85) translate(-50%, -50%)", // Escalar contenido para pantallas pequeñas
              maxHeight: "95vh", // Asegúrate de no exceder la pantalla
            },
          }}
        >
          {/* Título con imagen */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              mb: isMobile ? 2 : 4,
              textAlign: "center",
            }}
          >
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: "bold",
                color: "#222",
                textShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                fontSize: { xs: "1.2rem", sm: "1.8rem" },
              }}
            >
              Top de Áreas de Interés
            </Typography>

            <img
              src={logo}
              alt="Icono"
              style={{
                width: "70px",
                height: "70px",
              }}
            />
          </Box>

          {/* Contenido principal */}
           {/* Contenido principal */}
    {isMobile ? (
      // Contenido para dispositivos móviles
      <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        overflowY: "auto",
        height: "100%",
      }}
    >
      {/* Lista de áreas */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5, // Espacio entre los elementos
        }}
      >
        {getTopAreas().map((area) => (
          <Box
            key={area.area}
            sx={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#eef2f6",
              borderRadius: "8px",
              px: 2,
              py: 1,
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
              marginBottom: 1, 
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#333",
              }}
            >
              {area.area}
            </Typography>
            <Typography variant="body2">Carreras afines: {area.carreras}</Typography>
           {/* <Typography
              variant="body2"
              sx={{
                color: "#555",
              }}
            >
              {area.respuestas} respuestas
            </Typography>
            */} 
          </Box>
        ))}
      </Box>
  
      {/* Mensaje de agradecimiento */}
      <Box
        sx={{
          textAlign: "center",
          mt: 2,
          p: 2,
          backgroundColor: "#f9f9f9",
          borderRadius: "12px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#013cae",
            marginBottom: "6px",
          }}
        >
          ¡Gracias por tu tiempo!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: 1.8,
            color: "#555",
          }}
        >
          Al hacer clic en el botón "Cerrar", tus datos serán enviados a tu correo.
        </Typography>
      </Box>
    </Box>
      
    ) : (
      // Contenido para escritorio
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 3, md: 6 },
              overflowY: "auto", // Habilitar scroll si el contenido es muy alto
              flex: 1, // Permitir que el contenido se expanda dinámicamente
            }}
          >
            {/* Columna izquierda: Gráfico */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                p: { xs: 1, sm: 3 },
                borderRadius: "12px",
                backgroundColor: "#f9f9f9",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "10px",
                  color: "#555",
                  fontSize: { xs: "0.9rem", md: "1.2rem" },
                }}
              >
                Áreas de Interés
              </Typography>
              <Box sx={{ width: "100%", height: { xs: "200px", md: "350px" } }}>
                <BarChart data={dataResultado} />
              </Box>
            </Box>

            {/* Columna derecha: Lista de áreas */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                px: { xs: 1, sm: 3 },
              }}
            >
              {getTopAreas().map((area) => (
                <Tooltip
                  key={area.area}
                  title={
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: "#fff" }}
                      >
                        {area.area}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#fff" }}>
                        {area.descripcion || "Descripción no disponible"}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#eef2f6",
                      borderRadius: "8px",
                      px: { xs: 2, sm: 3 },
                      py: 2,
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color: "#333",
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      {area.area}
                      <Typography variant="body2">
                        Carreras afines: {area.carreras}
                      </Typography>
                    </Typography>
                  {/*  <Typography
                      variant="body1"
                      sx={{
                        color: "#555",
                        fontSize: { xs: "0.8rem", md: "0.9rem" },
                      }}
                    >
                      {area.respuestas} respuestas
                    </Typography> */}
                  </Box>
                </Tooltip>
              ))}
              {/* Agregar el nuevo Box al final */}
              <Box
                sx={{
                  textAlign: "center",
                  padding: { xs: "16px", sm: "24px" }, // Padding dinámico
                  backgroundColor: "#f9f9f9",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  color: "#333",
                  fontFamily: "Arial, sans-serif",
                  maxWidth: { xs: "100%", sm: "800px" }, // Ajuste dinámico del ancho
                  margin: "0 auto",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#013cae",
                    marginBottom: "16px",
                    fontSize: { xs: "1rem", sm: "1.25rem" }, // Tamaño de fuente dinámico
                  }}
                >
                  ¡Gracias por tu tiempo!
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    lineHeight: 1.8,
                    color: "#555",
                    fontSize: { xs: "0.9rem", sm: "1rem" }, // Tamaño de fuente dinámico
                  }}
                >
                  Al hacer clic en el botón "Cerrar", tus datos serán enviados al correo de la institución.
                  Daremos seguimiento a tus resultados para ayudarte a elegir la carrera de tu interés.
                  Te esperamos en la Universidad Católica para que formes parte de nuestra gran familia.
                </Typography>
              </Box>

            </Box>
          </Box>
         )}
          {/* Botón de cierre */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 3,
            }}
          >
            {isButtonVisible && (
  <Button
    variant="contained"
    sx={{
      px: { xs: 3, sm: 5 },
      py: { xs: 1, sm: 1.5 },
      fontSize: { xs: "0.8rem", sm: "1rem" },
      fontWeight: "bold",
      backgroundColor: "#013cae",
      color: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 5px 15px rgba(0, 123, 255, 0.3)",
      "&:hover": {
        backgroundColor: "#0056b3",
      },
    }}
    onClick={handleCloseModal}
  >
    Cerrar
  </Button>
)}
          </Box>
        </Box>
      </Modal>
</Box>
  );
};

export default Test;
